import { z } from "zod"

import { propertyKeySchema } from "./property-key"

export const ACCOUNT_PROPERTIES = [
  `customerClass`,
  `lseId`,
  `territoryId`,
] as const

export const AccountProperties = z.enum(ACCOUNT_PROPERTIES)

export const accountPropertiesSchema = z.object({
  customerClass: propertyKeySchema.optional(),
  lseId: propertyKeySchema.optional(),
  territoryId: propertyKeySchema.optional(),
})

export type AccountProperties = z.infer<typeof accountPropertiesSchema>
